import { useCallback } from 'react';
import { EventName } from '@bumble/proto/hotpanel';

import { useHotpanel } from 'lib/hotpanel/hotpanel-context-provider';
import { ProtoElementEnum } from 'lib/proto-types';

export const useHotpanelClickHandler = (
    element: ProtoElementEnum,
    parentElement?: ProtoElementEnum
) => {
    const { hotpanel } = useHotpanel();

    return useCallback(() => {
        hotpanel.trackEvent(EventName.EVENT_NAME_CLICK, {
            element,
            parent_element: parentElement,
        });
    }, [hotpanel, element, parentElement]);
};
